<template>
  <div class="relative w-full" :class="classes">
    <VueDatePicker
      ref="datePickerRef"
      :model-value="selectedDate"
      :placeholder="placeholder"
      :clearable="true"
      :enable-time-picker="format.includes('HH')"
      @update:model-value="handleDateChange"
      @cleared="clearDate" />

    <p v-if="errorMessage" class="absolute text-red-400 top-10 text-xsm">
      {{ errorMessage }}
    </p>
    <p v-if="successMessage" class="absolute text-green-400 top-10 text-xsm">
      {{ successMessage }}
    </p>
  </div>
</template>

<script>
import { useField } from "vee-validate"
import { toRef, ref, watch } from "vue"
import moment from "moment"
import VueDatePicker from "@vuepic/vue-datepicker"

export default {
  components: { VueDatePicker },
  props: {
    placeholder: {
      type: String,
      default: "Select Date"
    },
    classes: {
      type: String,
      default: ""
    },
    successMessage: {
      type: String,
      default: ""
    },
    format: {
      type: String,
      default: "YYYY-MM-DD"
    },
    value: {
      type: String,
      default: null
    },
    modelValue: {
      type: String,
      default: null
    },
    name: {
      type: String,
      required: true
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const name = toRef(props, "name")
    const initialDate = props.value || props.modelValue

    const {
      value: dateValue,
      errorMessage,
      handleBlur
    } = useField(name, undefined, {
      initialValue: initialDate
    })

    const selectedDate = ref(initialDate ? moment(initialDate, props.format).toDate() : null)

    const handleDateChange = (date) => {
      selectedDate.value = date

      if (!date) {
        console.warn("No date selected.")
        dateValue.value = null
        emit("update:modelValue", null)
        return
      }

      // Format the date and update the form field and parent component
      const formattedDate = moment(date).format(props.format)
      dateValue.value = formattedDate
      emit("update:modelValue", formattedDate)

      // Close the date picker menu
      datePickerRef.value.closeMenu()
    }

    const clearDate = () => {
      datePickerRef.value.closeMenu()
      selectedDate.value = null
      dateValue.value = null
      emit("update:modelValue", null)
    }

    const datePickerRef = ref(null)

    watch(
      () => props.modelValue,
      (newVal) => {
        if (newVal) {
          selectedDate.value = moment(newVal, props.format).toDate()
        } else {
          selectedDate.value = null
        }
      }
    )

    return {
      dateValue,
      errorMessage,
      handleBlur,
      handleDateChange,
      clearDate,
      datePickerRef,
      selectedDate
    }
  }
}
</script>
